import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {httpValidateAccesses, HttpValidateAccessesOptions} from '../http/accesses.http'
import {MUTATION_KEYS, queryClient, QUERY_KEYS} from '@/queryClient'

export const useValidateAccesses = (
    options?: Omit<UseMutationOptions<unknown, AxiosError, HttpValidateAccessesOptions['payload']>, 'mutationFn'>
) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.VALIDATE_ACCESS],
        mutationFn: payload => httpValidateAccesses({payload}),
        onSuccess: async (...args) => {
            await Promise.all([
                queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ACCESSES]}),
                queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ACTIVITY_REPORT_COUNTERS]})
            ])
            await options?.onSuccess?.(...args)
        }
    })
}
